import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { TicketFilterKey } from 'api/Tickets/Types/TicketDto'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { BooleanFilter } from '../BooleanFilter'
import {
  CustomDateTimeFilter,
  MultiClientProductSelectFilter,
  MultiCompanySelectFilter,
  MultiCountrySelectFilter,
  MultiSelectPaymentProviderFilter,
} from '../common.filter'
import { TicketReporterFilter } from './TicketReporterFilter'
import { TicketStatusFilter } from './TicketStatusFilter'
import { TicketTypeFilter } from './TicketTypeFilter'

export const getTicketBrokerageAndTranslationsFields = (): FieldSettings[] => [
  {
    name: TicketFilterKey.NUMBER,
    label: 'Number',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.TYPE,
    label: 'Type',
    filter: TicketTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.STATUS,
    label: 'Status',
    filter: TicketStatusFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.COUNTRY,
    label: 'Country',
    filter: MultiCountrySelectFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.PAYMENT_PROVIDER,
    label: 'Payment Provider',
    filter: MultiSelectPaymentProviderFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.TICKMILL_COMPANY,
    label: 'Company',
    filter: MultiCompanySelectFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.REPORTER,
    label: 'Reporter',
    filter: TicketReporterFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.DATE_CREATED,
    label: 'Date Created',
    filter: CustomDateTimeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.DATE_UPDATED,
    label: 'Date Updated',
    filter: CustomDateTimeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: TicketFilterKey.IS_INTERNAL_TEST_ACCOUNT,
    label: 'Is Test Client',
    filter: BooleanFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: 'ClientProduct',
    label: 'Client Product',
    filter: MultiClientProductSelectFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
